module.exports = __webpack_public_path__ + "static/media/bharatsharma.51746aea.png";